// const pairsData = [
// [
//     {
//         "id": 1,
//         "name": "Pomidorowa z kluskami",
//         "image": "https://i.wpimg.pl/180x100/filerepo.grupawp.pl/api/v1/display/embed/34fb0b7d-f007-4169-a38f-84819f3adf98#r",
//         "voted": 243123123,
//         "pageUrl": "/article/slug-artykulu-1"
//     },
//     {
//         "id": 3,
//         "name": "Gołąbki",
//         "image": "https://i.wpimg.pl/180x100/filerepo.grupawp.pl/api/v1/display/embed/34fb0b7d-f007-4169-a38f-84819f3adf98#r",
//         "voted": 12324,
//         "pageUrl": "/przepis-article/slug-artykulu-2"
//     }
// ],
// [
//     {
//         "id": 2,
//         "name": "Rosół z kołduanami",
//         "image": "https://i.wpimg.pl/180x100/filerepo.grupawp.pl/api/v1/display/embed/34fb0b7d-f007-4169-a38f-84819f3adf98#r",
//         "voted": 121,
//         "pageUrl": "/przepis-article/slug-artykulu-2"
//     },
//     {
//         "id": 4,
//         "name": "Parówki na bogato",
//         "image": "https://i.wpimg.pl/180x100/filerepo.grupawp.pl/api/v1/display/embed/34fb0b7d-f007-4169-a38f-84819f3adf98#r",
//         "voted": 21,
//         "pageUrl": "/article/slug-artykulu-1"
//     }
// ],
// [
//     {
//         "id": 5,
//         "name": "kotlet pożarty",
//         "image": "https://i.wpimg.pl/180x100/filerepo.grupawp.pl/api/v1/display/embed/34fb0b7d-f007-4169-a38f-84819f3adf98#r",
//         "voted": 24,
//         "pageUrl": "/article/slug-artykulu-1"
//     },
//     {
//         "id": 6,
//         "name": "tarte tatin",
//         "image": "https://i.wpimg.pl/180x100/filerepo.grupawp.pl/api/v1/display/embed/34fb0b7d-f007-4169-a38f-84819f3adf98#r",
//         "voted": 21,
//         "pageUrl": "/article/slug-artykulu-1"
//     },
// ],
// [
//     {
//         "id": 7,
//         "name": "kwaśnica na wieprzowinie",
//         "image": "https://ceph/pomidorowa.jpg",
//         "voted": 24,
//         "pageUrl": "/article/slug-artykulu-2"
//     },
//     {
//         "id": 8,
//         "name": "skrzydełka z KFC",
//         "image": "https://ceph/rosol.jpg",
//         "voted": 21,
//         "pageUrl": "/article/slug-artykulu-1"
//     }

// ]];

export const recipeVoting = async function (votingClass) {
    
    const votingContainers = document.querySelectorAll(votingClass);
    if (!votingContainers.length) return;

    const votingUrl = document.querySelector(votingClass).dataset.url;
    
    if (!votingContainers.length) return;

    const pairsDataMap = new Map(); // votingId => pairs[]
    const currentPairIndexMap = new Map(); // votingId => index

    const getPairTemplate = function (pair) {
        if (!pair || pair.length < 2) return '-';
        return `
            <div class="promo_voting__item">
                <img src="${pair[0].image}" alt="">
                <div class="voting_button" data-id="${pair[0].id}" data-name="${pair[0].name}">głosuj</div>
                <h2>${pair[0].name}</h2>
            </div>                
            <img src="https://kulinarna-stolica-polski.wpcdn.pl/i/vs.png">
            <div class="promo_voting__item">
                <img src="${pair[1].image}" alt="">
                <div class="voting_button" data-id="${pair[1].id}" data-name="${pair[1].name}">głosuj</div>
                <h2>${pair[1].name}</h2>
            </div>
        `;
    };

    const getResultsTemplate = function (pair) {
        if (!pair || pair.length < 2) return '-';
        return `
            <div class="promo_voting__item">
                <div class="promo_voting__count"><span>${objAll[pair[0].id].voted}</span> głosów</div>
                <a href="${pair[0].pageUrl}" class="promo_recipe">zobacz przepis</a>
                <h2>${pair[0].name}</h2>
            </div> 
            <div class="promo_voting__changePair_btn">głosuj dalej</div>
            <div class="promo_voting__item">
                <div class="promo_voting__count"><span>${objAll[pair[1].id].voted}</span> głosów</div>
                <a href="${pair[1].pageUrl}" class="promo_recipe">zobacz przepis</a>
                <h2>${pair[1].name}</h2>
            </div>
        `;
    };

    const fadeContent = (container, newHtml) => {
        container.style.transition = 'opacity 0.35s ease';
        container.style.opacity = 0;

        setTimeout(() => {
            container.innerHTML = newHtml;
            container.style.opacity = 1;
        }, 300); // czas krótszy niż transition!
    }
    
    //var allObj = { selectedId: {name: selectedName, voted: e.target.dataset.id} } format obiektu do przechowania danych
    
    const containerClick = async function (e) {
        const container = e.currentTarget;
        const votingEl = container.closest(votingClass);
        const votingId = votingEl.dataset.votingId;
        let pairIndex = currentPairIndexMap.get(votingId);
        const pairs = pairsDataMap.get(votingId);
    
        if (e.target.classList.contains('voting_button')) {
            const selectedId = e.target.dataset.id;
            const selectedName = e.target.dataset.name;
            
            console.log('Oddano głos na ID: ', selectedId, 'name: ' , selectedName);

            try {
                // POST z id wybranego przepisu
                const response = await fetch(votingUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ 
                        id: selectedId,
                        name: selectedName 
                    }),
                });
                console.log (selectedId + ', ' + selectedName)
                objAll[selectedId].voted += 1 
                if (!response.ok) {
                    throw new Error(`Błąd głosowania: ${response.status}`);
                }

                // Zakładamy, że głosy się aktualizują backendowo — używamy danych z cache
                const pair = pairs[pairIndex];
                fadeContent(container, getResultsTemplate(pair));

            } catch (err) {
                console.error("Błąd przy głosowaniu:", err);
                container.innerHTML = `<p>Błąd podczas głosowania. Spróbuj ponownie.</p>`;
            }

        } else if (e.target.classList.contains('promo_voting__changePair_btn')) {
            pairIndex++;
            if (pairIndex >= pairs.length) pairIndex = 0; // pętla od początku

            currentPairIndexMap.set(votingId, pairIndex);
            const nextPair = pairs[pairIndex];
            //container.innerHTML = getPairTemplate(nextPair);
            fadeContent(container, getPairTemplate(nextPair));
        }
    };

    for (const votingItem of votingContainers) {
        
        const votingId = votingItem.dataset.votingId || '1';        
        const container = votingItem.querySelector('.promo_voting__items');

        if (!votingUrl || !container) continue;

        try {
            const response = await fetch(votingUrl);
            if (!response.ok) throw new Error(`Błąd sieci: ${response.status}`);

            const pairs = await response.json();
            if (!pairs || !pairs.length) throw new Error("Brak danych par do głosowania");


            var objAll = {};
            //wszystkie dane do obiektu z kluczem id
            pairs.forEach(pair => {
                pair.forEach(item => {
                    objAll[item.id] = {
                    name: item.name,
                    voted: item.voted
                    };
                });
            });
            console.log(objAll);

            pairsDataMap.set(votingId, pairs);
            currentPairIndexMap.set(votingId, 0);

            // Ustaw pierwszą parę
            container.innerHTML = getPairTemplate(pairs[0]);

            // Obsługa kliknięć (głosowanie, zmiana pary)
            container.addEventListener('click', containerClick);

        } catch (err) {
            console.error(`Błąd dla votingId=${votingId}:`, err);
            container.innerHTML = `<p>Błąd ładowania głosowania</p>`;
        }
    }
};